module.exports = __webpack_public_path__ + "static/media/googlePin5.e4014737.svg";